import {VuexModule, Module, Mutation, Action, getModule} from 'vuex-module-decorators'
import {getSidebarStatus, getSize, setSidebarStatus, setLanguage, setSize} from '@/utils/cookies'
import {getLocale} from '@/lang'
import store from '@/store'
import {dxBoxOptions} from "devextreme/ui/box";
import NotifyService from '@/services/notify_service';
import ShareService from '@/services/share-service';
import {AxiosResponse} from "axios";
import request from "@/utils/request";

export enum DeviceType {
  Mobile,
  Desktop,
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
  language: string
  size: string
  db_schema: any
}

@Module({dynamic: true, store, name: 'app'})
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: getSidebarStatus() !== 'closed',
    withoutAnimation: false
  }
  public device = DeviceType.Desktop
  public language = getLocale()
  public size = getSize() || 'medium'
  public db_schema: any = [];
  public isConnected: boolean = true;
  public disconnectedTimeout: any = undefined;
  // Флаг выполнения бэкапа базы данных
  public isDbRestore: any = false;
  // флаг процесса аутентификации в Active Directory
  public fetchActiveDirectoryLogin: boolean = false;

  public socket = {
    isConnected: false,
    message: '',
    reconnectError: false,
  };

  @Mutation
  private CONNECTION_STATE (state: boolean) {
    if (this.isConnected && !state) {
      ShareService.CheckConnectionState();
    }
    this.isConnected = state;
  }


  @Mutation
  private SOCKET_ONOPEN (state: any, event: any) {

    this.socket.isConnected = true;
    console.log('--- WebSocket connected')
  }

  @Mutation
  private SOCKET_ONCLOSE (state: any, event: any) {
    this.socket.isConnected = false;
    console.log('--- WebSocket disconnected')
  }

  @Mutation
  private SOCKET_ONMESSAGE (state: any, message: any) {
    this.socket.message = message
  }

  @Mutation
  private SOCKET_ONERROR (state: any, event: any) {

  }

  @Mutation
  private SOCKET_RECONNECT (state: any, count: any) {

  }

  @Mutation
  private SOCKET_RECONNECT_ERROR (state: any) {
    this.socket.reconnectError = true;
  }

  @Mutation
  private SET_DB_SCHEMA(schema: any) {
    this.db_schema = {...schema};
  }

  @Mutation
  private SET_AD_LOGIN(value: boolean) {
    this.fetchActiveDirectoryLogin = value;
  }

  @Action
  public SetDbSchema(schema: any) {
    this.SET_DB_SCHEMA(schema)
  }

  @Action
  public SetConnectionState(connected: boolean) {

    this.CONNECTION_STATE(connected);

  }

  @Mutation
  private SOCKET_CONNECT() {
    this.isConnected = true;
  }

  @Mutation
  private SOCKET_DISCONNECT() {
    this.isConnected = false;
  }

  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      setSidebarStatus('opened')
    } else {
      setSidebarStatus('closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device
  }

  @Mutation
  private SET_LANGUAGE(language: string) {
    this.language = language
    setLanguage(this.language)
  }

  @Mutation
  private SET_SIZE(size: string) {
    this.size = size
    setSize(this.size)
  }

  @Mutation
  private SET_RESTORE_MODE(mode: boolean) {
    if (!mode) {
      // задержка после восстановления подключения во избежание 503 ошибки
      setTimeout(() => {
        if (this.isDbRestore) {
          NotifyService.success('Завершено восстановление базы данных из резервной копии', true);
        }
        this.isDbRestore = mode;

      }, 10000);
    } else {
      this.isDbRestore = mode;
    }

  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public SetLanguage(language: string) {
    this.SET_LANGUAGE(language)
  }

  @Action
  public SetSize(size: string) {
    this.SET_SIZE(size)
  }

  @Action
  public SetRestoreMode(mode: boolean) {
    this.SET_RESTORE_MODE(mode)
  }

  @Action
  public SetAdLogin(val: boolean) {
    this.SET_AD_LOGIN(val)
  }
}

export const AppModule = getModule(App)
